export default [
  {
    path: '/home/index',
    name: 'global-homePage',
    component: () => import('@/views/home/Index.vue')
  },
  {
    path: '/processing',
    name: 'processing',
    component: () => import('@/views/Processing.vue')
  },
  {
    path: '/creative-upload/:pageType/:folder*',
    name: 'manage-creativeHub',
    component: () => import('@/views/creative-upload/Index.vue')
  },
  {
    path: '/notifications',
    name: 'global-notificationsPage',
    component: () => import('@/views/pages/notifications/Index.vue')
  },
  {
    path: '/icon-preview',
    name: 'global-iconPreview',
    component: () => import('@/views/icon-preview/Index.vue')
  }
]
